import { ReactElement } from 'react';

import './main-container.scss';

interface IMainContainerContentProps {
  children?: ReactElement | Array<ReactElement>;
  className: string;
  sectionClassName?: string;
}

export const MainContainer = ({ children, className, sectionClassName }: IMainContainerContentProps) => (
  <div className={`main-container ${className}`}>
    <main className="main-container__main">
      <section className={sectionClassName || 'main-container__section'}>{children}</section>
    </main>
  </div>
);
